import { IApplicationState } from '../../types/redux';
import { TUserAnalytics } from '../../types/currentUser';

export const getUserForAnalytics = (state: IApplicationState): TUserAnalytics => {
  const { user } = state;

  if (user) {
    return {
      userId: user.realtyUserId,
    };
  }

  return {
    type: 'not_authorized',
  };
};
